import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=4d0ffc65&scoped=true&"
import script from "./Feed.vue?vue&type=script&lang=js&"
export * from "./Feed.vue?vue&type=script&lang=js&"
import style0 from "./Feed.vue?vue&type=style&index=0&id=4d0ffc65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ffc65",
  null
  
)

export default component.exports